import { useState, useCallback, useMemo } from "react";
import BreakdownDialog from "./BreakdownDialog";
import { assetTypeValues } from "../../../constants";

export const SUB_LEASE_WET_LEASE_BREAKDOWN_COLUMNS = [
  { key: "lease_ref_code", label: "Lease Ref Code" },
  { key: "lessee", label: "Lessee" },
  { key: "asset_label", label: "Asset" },
];

export const SUB_LEASE_KEY = "Sub Lease";
export const WET_LEASE_KEY = "Wet Lease";

function buildAssetRows(items, prefix) {
  if (!Array.isArray(items)) return [];
  return items.map((item, index) => ({
    id: `${prefix}-${item?.lease_ref_code || "lease"}-${index}`,
    lease_ref_code: item?.lease_ref_code || "-",
    lessee: item?.lessee || "-",
    asset_label: [assetTypeValues[item?.asset_type]?.label, item?.asset_sn].filter(Boolean).join(" ") || "-",
  }));
}

// Clicking the Sub Lease / Wet Lease row in the panel opens the popup with that type's assets breakdown.
export function useSubLeaseWetLeaseExposureBreakdown({ subLeaseBreakdown, wetLeaseBreakdown, onTrack }) {
  const [selectedType, setSelectedType] = useState(null);
  const reset = useCallback(() => setSelectedType(null), []);

  const subLeaseRows = useMemo(() => buildAssetRows(subLeaseBreakdown, "sub"), [subLeaseBreakdown]);
  const wetLeaseRows = useMemo(() => buildAssetRows(wetLeaseBreakdown, "wet"), [wetLeaseBreakdown]);
  const rows = selectedType === SUB_LEASE_KEY ? subLeaseRows : selectedType === WET_LEASE_KEY ? wetLeaseRows : [];

  const onRowClick = useCallback((type) => {
    setSelectedType(type);
    onTrack?.(`Graph Row Clicked: ${type}`);
  }, [onTrack]);

  return { rows, canRender: subLeaseRows.length > 0 || wetLeaseRows.length > 0, onRowClick, modalOpen: !!selectedType, closeModal: reset, titleSuffix: selectedType || "", reset };
}

export function SubLeaseWetLeaseExposureBreakdownModal({ open, onClose, rows, titleSuffix }) {
  const title = "Sub-Lease & Wet-Lease Exposure";
  const rowCount = Array.isArray(rows) ? rows.length : 0;
  const countLabel = `${rowCount} ${rowCount === 1 ? "Asset" : "Assets"}`;
  const subtitle = titleSuffix ? `${titleSuffix}  (${countLabel})` : countLabel;
  return (
    <BreakdownDialog
      open={open}
      onClose={onClose}
      title={title}
      subtitle={subtitle}
      exportFileName={titleSuffix ? `${title} - ${titleSuffix}` : title}
      columns={SUB_LEASE_WET_LEASE_BREAKDOWN_COLUMNS}
      rows={rows}
    />
  );
}
